._sectionHeader_1rtq8_1 {
  display: flex;
  width: 304px;
  height: 20px;
  margin: 0 auto 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid #8092a4; }

._sectionHeader_1rtq8_1 ._sectionAddPanelInfoIcon_1rtq8_9 svg path {
  fill: #3899ec; }

._title_1rtq8_12 {
  flex: 1 1 auto; }

._sectionInfoIcon_1rtq8_15 {
  flex: 0 0 auto; }

._infoIconImageContainer_1rtq8_18 {
  position: relative;
  cursor: pointer; }

._infoIconImageContainer_1rtq8_18 ._infoIconImage_1rtq8_18 {
  border: 4px solid #fff;
  border-radius: 6px;
  box-shadow: 0 0 0 1px #d9e1e8;
  width: 204px; }

._infoIconImageContainer_1rtq8_18 ._infoIconImage_1rtq8_18:hover {
  box-shadow: 0 0 0 2px #d3edff; }

._infoIconImageContainer_1rtq8_18 ._playVideoIcon_1rtq8_31 {
  position: absolute;
  top: calc(50% - 42px / 2);
  left: calc(50% - 42px / 2);
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background-color: rgba(22, 45, 61, 0.7);
  border: 2px solid #fff; }

._infoIconImageContainer_1rtq8_18 ._playVideoIcon_1rtq8_31:hover {
  border-color: #7fccf7; }

._infoIconImageContainer_1rtq8_18 ._playVideoIcon_1rtq8_31 .st0 {
  fill: #fff; }

._infoIconImageContainer_1rtq8_18 ._playVideoIcon_1rtq8_31:hover .st0 {
  fill: #7fccf7; }

._infoIconImageContainer_1rtq8_18 ._playVideoIcon_1rtq8_31 .st1 {
  fill: transparent; }

.classic-facelift-skin ._sectionHeader_1rtq8_1 {
  border-bottom: 1px solid #dfe5eb;
  padding-bottom: 7px;
  height: initial;
  color: #000624; }

.classic-facelift-skin ._sectionAddPanelInfoIcon_1rtq8_9 {
  margin-left: 12px; }

.classic-facelift-skin ._sectionAddPanelInfoIcon_1rtq8_9 svg path {
  fill: #868aa5; }

.classic-facelift-skin ._sectionAddPanelInfoIcon_1rtq8_9:hover svg path {
  fill: #116dff; }
